import { render, staticRenderFns } from "./CSCAstats.vue?vue&type=template&id=32faa73e&scoped=true&"
import script from "./CSCAstats.vue?vue&type=script&lang=js&"
export * from "./CSCAstats.vue?vue&type=script&lang=js&"
import style0 from "./CSCAstats.vue?vue&type=style&index=0&id=32faa73e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32faa73e",
  null
  
)

export default component.exports